<template>
    <router-view></router-view>
    <div class="loading-spinner" v-if="isLoading">
      <base-spinner></base-spinner>
    </div>
    <div class="post-wrap" v-if="!isLoading">
      <!-- <component :is="selectedComponent" >
        <p>Default Content </p>
      </component> -->
    
        <post-list  :document="document" />
    </div>
</template>

<script>
import PostList from "@/components/posts/PostList.vue";
//import PostListGallery from "@/components/posts/PostListGallery.vue";

export default {
  props:[
    'menu',
    'document',
  ],
  data() {
    return {
      //selectedComponent: PostList,
        isLoading:false,       
    };
  },
  created(){      
      //this.getList();
  },
  components: {
    PostList,
    //PostListGallery,
  },
  computed:{
      getDocument(){         
          return this.document
      },
      getMenu(){         
          return this.menu
      }
  },
  watch:{
    // $route:function(current){
    //   console.log(current)

    //   this.getList();
    // },
    // getDocument(curValue, oldValue) {     
    //   if (curValue && curValue !== oldValue ) {        
    //      this.getList();
    //   }
    // },
    // getMenu(curValue, oldValue) {     
    //   if (curValue && curValue !== oldValue) {        
    //      this.getList();
    //   }
    // },
    $route:function(current){
      console.log(current)
    }
  },
  methods:{
    // async getList(){
    //   const formData = {
    //     document: this.getDocument,
    //     menu:this.getMenu,
    //     page:1
    //   }
    //   this.isLoading =true;     
    //   try{
    //     const response = await this.$store.dispatch("posts/fetchLists", formData);
    //     console.log('게시글리스트업', response);
    //     this.isLoading =false;
    //   }catch(error){
    //     console.log('리스트업 에러', error)
    //   }
    // }
  }

};
</script>

<style scoped>
.post-wrap{
    border: 1px solid #dee3eb;

}
</style>

